import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { AppSpan, AppText, Circle, CustomContainer, FlexRow, FormGroupWithIcon, GridContainer, PageTitle, PageWrapper } from "src/style"
import { IoIosArrowBack } from "react-icons/io"
import utility from "src/utils/utility"
import { OutboundCalls } from "src/model"
import { FiChevronDown } from "react-icons/fi"
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco, dark, androidstudio } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import helpers from "src/utils/helpers"

const ApiCallDetails = () => {
    const navigate = useNavigate()
    const {info: {selectedApiCall}} = useContext(AppInfoContext)
    const [apiCall, setApiCall] = useState<OutboundCalls>(selectedApiCall)

    const apiRequestMethods = ["GET", "POST", "PUT", "DELETE", "PATCH"]

    // let codeString = `{
    //     "phoneNumber": "string",
    //     "message": "string",
    //     "institutionCode": "string",
    //     "loanReferences": "string"
    // }`

    useEffect(() => {
        if (selectedApiCall) setApiCall(selectedApiCall)
    }, [selectedApiCall])

    return (
        <PageWrapper>
            <FlexRow 
                width="auto" sizeUnit="" gap="1"
                onClick={() => navigate(-1)}
            >
                <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                    <IoIosArrowBack />
                </AppSpan>
                <Circle 
                    size="5" bgColor='#ffffff' 
                    borderColor='#EAECF0'
                    className='fixed-flex-shape'
                    style={{overflow: 'hidden'}}
                >
                    <Circle 
                        size='4'
                        style={{overflow: 'hidden'}}
                    >
                        <img 
                            src={apiCall?.logoUrl} 
                            className='img-covered' 
                            style={{objectFit: 'contain'}} 
                        />
                    </Circle>
                </Circle>
                <PageTitle 
                    color='#101828' textSize='3' fontWeight="500"
                >
                    API Call request details
                </PageTitle>
            </FlexRow>
            <CustomContainer topMargin='2'>
                <FormGroupWithIcon 
                    style={{width: '21rem'}}
                >
                    <div className="input-with-icon">
                        <select 
                            value={apiCall.method}
                            style={{color: apiCall.method ? '#101828' : '#667085'}}
                            disabled
                        >
                            <option value="">---</option>
                            {
                                apiRequestMethods?.map((method: string, index) => {
                                    return (
                                        <option value={method} key={index}>{method}</option>
                                    )
                                })
                            }
                        </select>
                        <FiChevronDown className="input-with-icon-tag" />
                    </div>
                </FormGroupWithIcon>
                <CustomContainer topMargin='1.5'>
                    <FlexRow
                        minHeight='11.7' padding='2.5' wrap='wrap'
                        borderColor='#EAECF0' radius='0.8' gap='3'
                        bgColor='#ffffff' justifyContent='space-between'
                        alignItems='flex-start'
                    >
                        {
                            dataToView.map((item, index) => {
                                return (
                                    (item.type === apiCall.type || item.type === 'all') &&
                                        <CustomContainer 
                                            width='auto' sizeUnit=''
                                            key={index}
                                        >
                                            <AppText 
                                                color='#333542' fontWeight="600" textSize='1.6'
                                            >
                                                {item.label}
                                            </AppText>
                                            { item.key === 'responseStatus' ?
                                                <GridContainer 
                                                    width='auto' sizeUnit=""
                                                    minWidth = '6.5' minHeight='2.5'
                                                    bgColor={apiCall.responseStatus === 'Successful' ? '#ECFDF3' : '#FEE4E2'} 
                                                    topPadding='0' bottomPadding='0' 
                                                    padding='0.8' radius='1.6'
                                                >
                                                    <AppSpan 
                                                        color={apiCall.responseStatus === 'Successful' ? '#027A48' : '#B42318'} 
                                                        fontWeight="500" textSize="1.2"
                                                    >
                                                        {apiCall.responseStatus}
                                                    </AppSpan>
                                                </GridContainer>
                                                :
                                                <AppSpan 
                                                    color='#333542' fontWeight='300'
                                                >
                                                    {item.key === 'dateCreated' ? (helpers.handleDate(apiCall.dateCreated)) : apiCall[item.key as keyof typeof apiCall]}
                                                </AppSpan>
                                            }
                                        </CustomContainer>
                                )
                            })
                        }
                    </FlexRow>
                </CustomContainer>
                <CustomContainer 
                    topMargin="2.5" radius="0.8"
                    padding="2" bgColor="#ffffff"
                    minHeight="30" borderColor="#EAECF0"
                    box-shadow='0px 1px 2px 0px #1018280F;0px 1px 3px 0px #1018281A'

                >
                    <AppText 
                        textSize="1.7" color="#101828" 
                        fontWeight="600" bottomMargin="1.5"
                    >
                        {apiCall.type === 'outbound' ? 'Request sent' : 'Request received'}
                    </AppText>
                    { apiCall.request &&
                        <SyntaxHighlighter 
                            language="json" style={docco}
                            showLineNumbers 
                            wrapLines
                        >
                            {apiCall.request}                             
                        </SyntaxHighlighter>
                    }
                </CustomContainer>
            </CustomContainer>
        </PageWrapper>
    )
}

export default utility.routeData('administration/product/:productId/api-calls/:apiCallId', 'API CALL Details', <ApiCallDetails/>)


const dataToView = [
    {label: 'Product', key: 'productName', type: 'all'},
    {label: 'Call time', key: 'callTime', type: 'outbound'},
    {label: 'Duration', key: 'duration', type: 'outbound'},
    {label: 'Time received', key: 'timeReceived', type: 'inbound'},
    {label: 'Response Status', key: 'responseStatus', type: 'all'},
    {label: 'Response Code', key: 'responseCode', type: 'outbound'},
    {label: 'Date', key: 'dateCreated', type: 'all'}
]